import { useTranslation } from 'react-i18next';

const LANGS = [
  { code: 'en', flag: '\u{1F1EC}\u{1F1E7}', label: 'EN' },
  { code: 'uk', flag: '\u{1F1FA}\u{1F1E6}', label: 'UK' },
] as const;

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = LANGS.find((l) => l.code === i18n.language) ?? LANGS[0];
  const next = LANGS.find((l) => l.code !== current.code)!;

  return (
    <button
      onClick={() => i18n.changeLanguage(next.code)}
      className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium text-(--color-text-secondary) hover:bg-(--color-bg-tertiary) hover:text-(--color-text-primary) transition-colors"
      title={`Switch to ${next.label}`}
    >
      <span>{current.flag}</span>
      <span>{current.label}</span>
    </button>
  );
}
